export default {
  home: 'Inicio',
  FAQs: 'Preguntas frecuentes',
  register: 'Registrarse',
  contactUs: 'Contáctenos',
  signIn: 'Iniciar sesión',
  languageButton: 'English',
  termsOfUse: 'Términos de uso',
  disclaimer: 'Renuncia de responsabilidad',
  noticeOfNonDiscrimination: 'Aviso de no discriminación',
  copyright:
    'Copyright \u00A9 {year} MDLIVE Inc. Reservados todos los derechos.',
  displayTitle: 'Registrarse para {affiliationName}.',
  displayTagline: 'Una forma más rápida de bienestar.',
  displayInfo: 'Convenientes, visitas reales con un {providerTypes} en línea.',
  providerTypes:
    'Médico certificado por la junta, proveedor de salud conductual o dermatólogo',
  subtitle: 'Tu información',
  firstName: 'Nombre',
  lastName: 'Apellido',
  email: 'Su correo electrónico actual',
  username: 'Crea tu nombre de usuario',
  password: 'Crea una contraseña',
  passwordRequirement1: 'Use una contraseña diferente de su nombre de usuario',
  passwordRequirement2: 'Debe tener entre 8 y 20 caracteres',
  passwordRequirement3: 'Debe tener al menos 1 letra mayúscula',
  passwordRequirement4: 'Debe tener al menos 1 letra minúscula',
  passwordRequirement5: 'Debe tener al menos 1 carácter especial',
  passwordRequirement6: 'La contraseña distingue mayúsculas',
  showPassword: 'Mostrar contraseña',
  alreadyMember: '¿Ya eres usuario?',
  signInHere: 'Firme aquí',
  nextButton: 'SIGUIENTE',
  dateOfBirth: 'Fecha de nacimiento',
  phoneNumber: 'Número de teléfono',
  zipCode: 'Código postal',
  gender: 'Género',
  male: 'Masculino',
  female: 'Femenino',
  nonBinary: 'No binario',
  nonBinaryTooltip:
    'Una persona no binaria es alguien que no se identifica como hombre o mujer.',
  receiveBenefitQuestion:
    '¿Recibe {affiliationName} como un beneficio a través de un empleador, un proveedor de seguros o una organización?',
  yesButton: 'Sí',
  noButton: 'No',
  agreeToTerms: 'Acepto los {termsLink} y la {privacyLink}.',
  termsOfService: 'Términos de servicio',
  privacyPolicy: 'Política de privacidad',
  createAccount: 'Crear una cuenta',
  affiliationCoverageText:
    'MDLIVE se ha asociado con {affiliationCoverageName} para proporcionar acceso a proveedores locales donde sea más conveniente para usted: ¡en casa, en la oficina o mientras viaja! Puede realizar una visita virtual con un proveedor de {affiliationCoverageName} a través de un teléfono inteligente, tableta o computadora para problemas médicos que no sean de emergencia 24/7/365.',
  affiliationCoverageCTAText:
    'Haga clic en Sí a continuación para acceder a los médicos de {affiliationCoverageName}, uno de los sistemas de salud más confiables del país.',
  benefitDisplayTitle: '{affiliationName} como un beneficio.',
  oops: '¡Uy!',
  'eligibilityError.Text1':
    'Disculpe, pero no podemos confirmar su información de elegibilidad en este momento. Comuníquese con su administrador de beneficios para verificar su elegibilidad. También puede intentar volver a ingresar su información y verificar nuevamente.',
  'eligibilityError.Text2':
    'Si selecciona Continuar a continuación, {affiliationName} le permitirá continuar registrándose, pero su tarjeta de crédito estará autorizada por el monto total de la consulta hasta que podamos verificar su elegibilidad para ajustar su pago final adeudado en consecuencia.',
  'eligibilityError.Text3':
    'Si cree que se trata de un error, comuníquese con nuestro equipo de Atención al cliente o también puede intentar volver a ingresar su información y verificar nuevamente.',
  'eligibilityError.pleaseCall': 'Por favor llama',
  multipleBenefitProviders:
    'Encontramos varios posibles proveedores de beneficios para usted. Por favor seleccione uno para continuar.',
  backButton: '{backArrow} Atrás',
  continueButton: 'Seguir',
  getStarted: 'Empecemos',
  benefitProviderSearch: 'Búsqueda de proveedores de beneficios',
  benefitProviderTooltip:
    'Escriba más caracteres para obtener mejores resultados.',
  businessUnit: 'Unidad de negocio',
  insurancePlan: 'Plan de seguro',
  medicalInsuranceID: 'Identificación del seguro médico',
  isInsuredAsDependent: '¿Está asegurado como dependiente?',
  signupButton: 'Regístrate',
  verifyButton: 'Verificar',
  noMatchFound: 'No se encontraron coincidencias',
  primaryPolicyHolder: 'Titular de la póliza primaria',
  primaryInsuranceID: 'Identificación del seguro primario',
  relationshipToPolicyHolder: 'Relación con el tomador del seguro',
  spouse: 'Cónyuge',
  child: 'Hijos',
  otherAdult: 'Otra adulta',
  'validationError.differentUsername':
    'Debe ser diferente al nombre de usuario',
  'validationError.8to20characters': '8 a 20 caracteres',
  'validationError.min1number': 'al menos un número',
  'validationError.requiredUppercase': 'al menos una letra mayuscula',
  'validationError.requiredLowercase': 'al menos una letra minúscula',
  'validationError.requiredSpecialCharacter': 'al menos 1 carácter especial',
  'validationError.validEmail': 'Use un correo electrónico válido',
  'validationError.usernameTaken': 'Error, el nombre de usuario ya existe.',
  'validationError.6to30characters': '6 a 30 caracteres, al menos una letra',
  'validationError.leastOneLetter':
    'Al menos una letra, sin espacios ni caracteres especiales (&,%, *)',
  'validationError.noSpacesOrSpecialChars':
    'Sin espacios ni caracteres especiales (&, %, *)',
  'validationError.invalidDate': 'Fecha inválida',
  'validationError.phone10digits': 'Solo debe contener 10 dígitos',
  'validationError.phoneDigitsOnly': 'sin guiones ni paréntesis',
  'validationError.zipNumbersOnly': 'solo debe contener números',
  'validationError.zip5characters': 'Debe tener 5 caracteres',
  'validationError.required': 'Necesario',
};



// WEBPACK FOOTER //
// ./translations/es.js